import { Editor } from '@toast-ui/react-editor';
import React, { useRef } from 'react';
import '@toast-ui/editor/dist/toastui-editor.css';
import { debounce } from '@util/debounce';

interface UpdateEditorProps {
  onChange: (content: string) => void;
}

const UpdateEditor: React.FC<UpdateEditorProps> = ({ onChange }) => {
  const editor = useRef<Editor | null>(null);

  const debouncedChange = debounce(() => {
    const markdown = editor.current?.getInstance().getMarkdown();
    onChange(markdown ?? '');
  }, 300);

  return (
    <div className='my-8'>
      <h1 className='font-semibold mb-2 text-xl'>Type your update below</h1>
      <Editor
        ref={editor}
        initialEditType='wysiwyg'
        usageStatistics={false}
        placeholder='Write something!'
        onKeyup={debouncedChange}
        customHTMLRenderer={{
          softbreak(_, { options }) {
            return {
              type: 'html',
              content: options.softbreak,
            };
          },
        }}
        useCommandShortcut={true}
      ></Editor>
    </div>
  );
};

export default UpdateEditor;
